import Vue from 'vue';
import axios from 'axios';

const VUE_APP_STATIC_API_URL = process.env.VUE_APP_STATIC_API_URL || 'http://localhost:3001/api/v1';

const instance = axios.create({
  baseURL: VUE_APP_STATIC_API_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'accept-language': localStorage.getItem('sidar-lang') || 'en',
  },
});

// Auto set last activity timestamp on requests
instance.interceptors.request.use(
  (config) => {
    localStorage.setItem('sidar-last-activity', Date.now().toString());
    return config;
  },
  (error) => Promise.reject(error)
);

// Inject globally as this.$axios
Vue.prototype.$axios = instance;

export default instance;
